var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Lista de eventos del regante")]),_c('EventListFilter',{staticClass:"mt-2"}),_c('EventList'),_c('p',{staticClass:"text-center mt-2"},[_c('EventListNext')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }